import * as Library from '../../../../lib/core/library/index';
import { Color } from './color';

export class ExteriorColor extends Color {
  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    super(options);
  }
}
